import script from "./RelatorioAtividadeModeloForm_10.vue?vue&type=script&setup=true&lang=js"
export * from "./RelatorioAtividadeModeloForm_10.vue?vue&type=script&setup=true&lang=js"

import "./RelatorioAtividadeModeloForm_10.vue?vue&type=style&index=0&id=30e0c729&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-30e0c729"]])

export default __exports__